











































import Vue from 'vue'
import './SocialDetails.scss'

export default Vue.extend({
  name: 'SocialDetails',
  props: {
    platform: {
      type: String,
      default: 'instagram'
    },
    asset: {
      type: Object
    }
  },
  watch: {
    asset (newValue) {
      if (typeof newValue?.data !== 'string') return newValue
      // @ts-ignore
      this.asset = { ...newValue, data: JSON.parse(newValue) }  // eslint-disable-line vue/no-mutating-props
    }
  },
  data: () => ({
    isSelecting: false,
    selectionPreview: '', // shown while selecting
    maxChars: 280,
    editing: false,
    maxLengthExceeded: false
  }),
  mounted (): void {
    this.detectUsername()
    document.addEventListener('mousedown', this.handleMouseDown.bind(this))
    document.addEventListener('mousemove', this.handleMouseMove.bind(this))
    document.addEventListener('mouseup', this.handleMouseUp.bind(this))
  },
  beforeDestroy (): void {
    document.removeEventListener('mousedown', this.handleMouseDown.bind(this))
    document.removeEventListener('mousemove', this.handleMouseMove.bind(this))
    document.removeEventListener('mouseup', this.handleMouseUp.bind(this))
  },
  computed: {
    image (): string {
      if (!this.asset.data?.media_url) return ''
      else return this.asset.data.media_url
    },
    handle (): string {
      if (!this.asset?.data?.user) return '...'
      else return this.asset.data.user.name
    },
    imagestyle (): Partial<CSSStyleDeclaration> {
      const style = {
        backgroundImage: 'url(' + this.image + ')',
        backgroundSize: 'contain'
      } as Partial<CSSStyleDeclaration>
      return style
    },
    selectionLength (): number {
      if (!this.isSelecting) return 0
      else return this.selectionPreview.length
    },
    selectedText (): string {
      const existingText = this.selectionPreview || this.asset.data.selectedText || this.asset.data.text
      if (this.isSelecting) return this.selectionPreview
      else return this.$options.filters?.maxLen(existingText, this.maxChars)
    }
  },
  methods: {
    startEditing (): void {
      this.maxLengthExceeded = false
      this.editing = true
    },
    stopEditing (): void {
      this.isSelecting = false
      this.editing = false
    },
    detectUsername (): void {
      if (!this.asset?.data) return
      const userDataMissing = !this.asset.data.user
      if (!userDataMissing) return

      this.$store.direct.dispatch.assets.updateInstagramWithUsername(this.asset.id)
    },
    handleMouseDown (event: MouseEvent): void {
      if (event.target !== this.$refs.selectableText) return
      this.isSelecting = true
      this.selectionPreview = this.selectedText
    },
    handleMouseMove (event: MouseEvent): void {
      if (!this.isSelecting || event.target !== this.$refs.selectableText) return
      this.updateTextSelection()
    },
    handleMouseUp (event: MouseEvent): void {
      this.stopEditing()

      if (event.target !== this.$refs.selectableText) return
      if (!window) return // is this needed? in what case is there no 'window' object?

      const selection = window.getSelection()
      if (!selection) return 

      const selectedText: string = selection.toString().trim()
      if (!selectedText) return

      if (this.asset.data.selectedText === selectedText) return
      this.commitSelection()
    },
    updateTextSelection (): void {
      const selection = window.getSelection()
      if (!selection) return

      const selectedText: string = selection.toString().trim()
      if (!selectedText) return

      this.updateSelectionPreview(selectedText)
    },
    updateSelectionPreview (text: string): void {
      if (!text) return
      this.maxLengthExceeded = text.length > this.maxChars
      this.selectionPreview = text
    },
    commitSelection (): void {
      this.updateTextSelection()

      const data = { ...this.asset.data, selectedText: this.selectionPreview }
      this.$emit('changed', { ...this.asset, data })

      // NOTE: do not change referenced prop directly (!)
      // this.asset.data.selectedText = this.selectionPreview
      // this.$emit('changed', this.asset)
    }
  }
})
